/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.58"
        height="74.09"
        viewBox="0 0 95.58 74.09"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M32.86 0h-.14a1.21 1.21 0 0 0-1 .84l-4.88 14.19h-5.17V12.2a3.22 3.22 0 0 0-3.17-3.21H9.82a3.2 3.2 0 0 0-3 3.21v2.83H4.55a4.52 4.52 0 0 0-4.57 4.52v50.12a4.52 4.52 0 0 0 4.55 4.47h86.49a4.52 4.52 0 0 0 4.54-4.47V19.3a4.51 4.51 0 0 0-4.54-4.26h-22.3L63.89.85A1.25 1.25 0 0 0 62.71 0Zm.89 2.5h28.08l4.83 14.19a1.29 1.29 0 0 0 1.19.85h23.19a2 2 0 0 1 2 2v50.12a2 2 0 0 1-2 2H4.55a2 2 0 0 1-2-2V19.55a2 2 0 0 1 2-2h3.49a1.25 1.25 0 0 0 1.25-1.25v-4.05a.71.71 0 0 1 .71-.71h8.5a.72.72 0 0 1 .72.71v4.09a1.25 1.25 0 0 0 1.2 1.21h7.45a1.27 1.27 0 0 0 1.05-.84Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M57.14 6.29a1.23 1.23 0 0 1 1.24 1.12v3.55a3.23 3.23 0 0 1-3 3.22h-15a3.21 3.21 0 0 1-3.21-3V7.55a1.25 1.25 0 0 1 1.18-1.32 1.27 1.27 0 0 1 1.32 1.19v3.55a.73.73 0 0 0 .63.72h14.84a.72.72 0 0 0 .71-.62V7.55a1.24 1.24 0 0 1 1.29-1.26ZM47.79 20.55A23.12 23.12 0 1 0 70.9 43.69a23.11 23.11 0 0 0-23.11-23.14Zm0 2.5a20.62 20.62 0 1 1-20.61 20.64 20.62 20.62 0 0 1 20.61-20.64Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M47.44 23.03a20.6 20.6 0 1 0 .7 0Zm.73-2.5a23.11 23.11 0 1 1-.76 0Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M47.79 27.7a15.94 15.94 0 0 1 0 31.87 1.25 1.25 0 0 1 0-2.5 13.44 13.44 0 1 0-13.43-13.45 1.25 1.25 0 1 1-2.5 0A16 16 0 0 1 47.79 27.7Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'CameraIcon';

export default Icon;
